import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 4, viewBox: "0 0 10 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5 4L9.33013 0.25H0.669873L5 4Z", fill: "#9C9C9C" }));
export default SvgChevronDown;
